module.exports = __webpack_public_path__ + "static/media/trash.fbc2d62e.svg";